import { Text } from "@amzn/storm-ui";
import React from "react";

export const OpportunityLinkageText: React.FunctionComponent = () => {
    return (
        <Text data-testid="opportunity-linkage-text">
            If you cannot find a relevant option, please provide reasons and
            feedback using <strong>"Share Feedback"</strong> under the{" "}
            <strong>"Contact Us"</strong> menu in the top right corner of the
            page.{" "}
        </Text>
    );
};
